export default __webpack_public_path__ + "static/media/KYC.b26c29e6.png";